import React from "react";
import "./gettingStarted.css";
import { connect } from "react-redux";
import Container from "../container/container";
import {
  Sidebar,
  SidebarHeader,
  SidebarViewAll,
  SideBar,
  SidebarRight,
  SidebarLeft,
} from "../layouts/layout1";
import Step from "../step/step";
import Authorization from "../authorization/authorization";
import Title from "../title/title";
import Heading from "../heading/heading";
import Divider from "../divider/divider";

function GettingStarted(props) {
  const { blocks } = props;
  return (
    <div>
      <section>
        <Container>
          <Container inner>
            <SideBar>
              <SidebarLeft>
                <div>
                  <SidebarHeader>
                    <Title type="section">
                      <Heading
                        level="1"
                        className="display-effect"
                        style={{ width: "250px" }}
                        dangerouslySetInnerHTML={{
                          __html: "GETTING </br> STARTED",
                        }}
                      />
                    </Title>
                  </SidebarHeader>
                  <SidebarViewAll />
                </div>
              </SidebarLeft>
              <SidebarRight>
                <div className="timeline">
                  <div className="dots_section dots_bg" />
                  <div className="lines_section lines_bg" />
                  <ul>
                    {blocks.length
                      ? blocks.map((block, index) =>
                          blocks.length === index + 1 ? (
                            <Authorization
                              key={"started" + index}
                              title={block.title}
                              description={block.description}
                              link={block.link}
                            />
                          ) : (
                            <Step
                              key={"started" + index}
                              title={block.title}
                              description={block.description}
                              link={block.link}
                              number={index + 1}
                            />
                          )
                        )
                      : null}
                  </ul>
                </div>
              </SidebarRight>
            </SideBar>
          </Container>
          <Divider />
        </Container>
      </section>
      <section>
        <Container>
          <div className="allDone">
            <span>ALL DONE</span>
          </div>
          <div className="allDoneDescr">
            <p>You are signed up, registered and ready to go.</p>
          </div>
          <Divider />
        </Container>
      </section>
    </div>
  );
}

const parseBlocks = (blocks) => {
  if (!blocks || !blocks.length) return [];

  // Handle plain JavaScript array
  if (Array.isArray(blocks)) {
    return blocks.map((block) => ({
      title: block.title || "",
      description: block.description || "",
      link: {
        url: block.link?.url || "",
        title: block.link?.title || "",
        external: block.link?.external || false,
      },
    }));
  }

  // Handle Immutable.js (legacy)
  if (blocks.size !== undefined) {
    return blocks
      .valueSeq()
      .toArray()
      .map((block) => ({
        title: block.get("title"),
        description: block.get("description"),
        link: {
          url: block.getIn(["link", "url"]),
          title: block.getIn(["link", "title"]),
          external: block.getIn(["link", "external"]),
        },
      }));
  }

  return [];
};

const mapStateToProps = (state) => ({
  blocks: parseBlocks(state.general?.getting_started || []),
});

export default connect(mapStateToProps, null)(GettingStarted);
